// extracted by mini-css-extract-plugin
export default {"item":"_LuiINRp","buttons":"o05vtR9i","mobile":"DLooMibL","regButton":"Wyjq5j7z"};